import React from 'react';
import { useLocation } from 'react-router-dom';

import HardlockImage from '../../assets/hardlock.png';
import HardlockImageEng from '../../assets/hardlockeng.png';

const Hardlock = () => {
    const location = useLocation();
    const locationSignature = `${location.pathname}${location.search}${location.hash}`.toLowerCase();
    const isEnglishVersion = locationSignature.includes('eng');

    const imageSrc = isEnglishVersion ? HardlockImageEng : HardlockImage;
    const altText = isEnglishVersion ? 'Hardlock English' : 'Hardlock';

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#000'
            }}
        >
            <a
                href="mailto:hamsa@ooppah.com?subject=Contato%20Hardlock"
                style={{ display: 'inline-block' }}
            >
                <img
                    src={imageSrc}
                    alt={altText}
                    style={{ maxWidth: '100%', height: 'auto' }}
                />
            </a>
        </div>
    );
};

export default Hardlock;
